var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:['menu-icon', _vm.icon, { mask: _vm.mask }],attrs:{"role":"img"}},[_c('use',{attrs:{"width":"100%","height":"100%","xlinkHref":`${_vm.icons[_vm.icon]}#${_vm.icon}`,"href":`${_vm.icons[_vm.icon]}#${_vm.icon}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }